import { atom, useAtomValue } from "jotai";

import { loadingAtom } from "@/states/loading/atoms";
import { LoadingUiState } from "@/states/loading/types";

const loadingUiStateAtom = atom<LoadingUiState>((get) => {
  const { tasks, customText } = get(loadingAtom);

  if (tasks.length === 0) {
    return {
      status: "NotLoading",
      customText,
    };
  }

  return {
    status: "Loading",
    customText,
    tasks: tasks,
  };
});

export const useLoadingUiState = (): LoadingUiState =>
  useAtomValue(loadingUiStateAtom);
